/*
 * Lentila standalone "Write a Review" form (QR landing).
 * Open mode: nickname + rating + text + photos, no purchase verification.
 * Posts to the App Proxy (/apps/reviews) with mode:"open". Moderated before publish.
 */
(function () {
  'use strict';

  var MAX_PHOTOS = 4;
  var MAX_DIM = 1280;
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  var MSG = {
    invalid_rating: 'Please select a star rating.',
    invalid_body: 'Please enter at least 10 characters.',
    invalid_email: 'Please enter a valid email address.',
    default: 'Something went wrong. Please try again later.',
    bad_signature: 'Request verification failed. Please refresh the page.',
  };

  function init(root) {
    if (root.__lrwInit) return;
    root.__lrwInit = true;

    var proxy = root.getAttribute('data-proxy') || '/apps/reviews';
    var productId = root.getAttribute('data-product-id');
    var form = root.querySelector('[data-lrw-form]');
    var doneEl = root.querySelector('[data-lrw-done]');
    if (!form) return;

    var ratingInput = form.querySelector('input[name="rating"]');
    var starBtns = form.querySelectorAll('[data-lrw-stars] .lrw-star');
    var photoInput = form.querySelector('[data-lrw-photos]');
    var previews = form.querySelector('[data-lrw-previews]');
    var msg = form.querySelector('[data-lrw-msg]');
    var photos = [];

    starBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(btn.getAttribute('data-value'), 10);
        ratingInput.value = val;
        starBtns.forEach(function (b) {
          b.classList.toggle('is-on', parseInt(b.getAttribute('data-value'), 10) <= val);
        });
      });
    });

    photoInput.addEventListener('change', function () {
      var files = Array.prototype.slice.call(photoInput.files);
      photoInput.value = '';
      files.forEach(function (file) {
        if (photos.length >= MAX_PHOTOS) return;
        if (!/^image\//.test(file.type)) return;
        shrink(file, function (dataUrl) {
          if (photos.length >= MAX_PHOTOS) return;
          photos.push(dataUrl);
          renderPreviews();
        });
      });
    });

    function renderPreviews() {
      previews.innerHTML = photos.map(function (p, i) {
        return '<figure><img src="' + p + '" alt=""><button type="button" data-i="' + i + '">×</button></figure>';
      }).join('');
      previews.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          photos.splice(parseInt(b.getAttribute('data-i'), 10), 1);
          renderPreviews();
        });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('input[name="email"]').value.trim();
      var rating = parseInt(ratingInput.value, 10) || 0;
      var body = form.querySelector('textarea[name="body"]').value.trim();

      setMsg('', '');
      if (!EMAIL_RE.test(email)) return setMsg(MSG.invalid_email, 'is-error');
      if (!rating) return setMsg(MSG.invalid_rating, 'is-error');
      if (body.length < 10) return setMsg(MSG.invalid_body, 'is-error');

      var submitBtn = form.querySelector('.lrw-submit');
      submitBtn.disabled = true;
      setMsg('Submitting…', '');

      fetch(proxy, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          mode: 'open',
          productId: productId,
          email: email,
          rating: rating,
          body: body,
          photos: photos,
        }),
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          submitBtn.disabled = false;
          if (res.ok && res.body.ok) {
            form.hidden = true;
            if (doneEl) doneEl.hidden = false;
          } else {
            var code = (res.body && res.body.error) || 'default';
            setMsg(MSG[code] || MSG.default, 'is-error');
          }
        })
        .catch(function () {
          submitBtn.disabled = false;
          setMsg(MSG.default, 'is-error');
        });
    });

    function setMsg(text, cls) {
      msg.textContent = text;
      msg.className = 'lrw-msg' + (cls ? ' ' + cls : '');
    }

    function shrink(file, cb) {
      var img = new Image();
      var reader = new FileReader();
      reader.onload = function () {
        img.onload = function () {
          var w = img.width, h = img.height;
          if (w > h && w > MAX_DIM) { h = Math.round((h * MAX_DIM) / w); w = MAX_DIM; }
          else if (h >= w && h > MAX_DIM) { w = Math.round((w * MAX_DIM) / h); h = MAX_DIM; }
          var canvas = document.createElement('canvas');
          canvas.width = w; canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);
          cb(canvas.toDataURL('image/jpeg', 0.8));
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  function boot() {
    document.querySelectorAll('[data-lr-write]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
